import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class QuickGuideVisibilityService {
  readonly enabled = Boolean(environment.quickGuideEnabled);

  isEnabled(): boolean {
    return this.enabled;
  }
}
